import type {
  CreateAdjustmentInput,
  CreateTransferInput,
  Paginated,
  StockBalance,
  StockMovement,
} from '@fdt/shared';
import { api } from '../api/client';

/** Either a warehouse or a vehicle, as the stock endpoints expect it. */
export type StockLocationRef =
  | { kind: 'warehouse'; id: string }
  | { kind: 'vehicle'; id: string };

function locationParams(location: StockLocationRef): Record<string, string> {
  return location.kind === 'warehouse' ? { warehouseId: location.id } : { vehicleId: location.id };
}

export const stockApi = {
  async balance(location: StockLocationRef): Promise<StockBalance[]> {
    const { data } = await api.get<StockBalance[]>('/stock/balance', {
      params: locationParams(location),
    });
    return data;
  },

  async movements(params: {
    page: number;
    pageSize: number;
    warehouseId?: string;
    vehicleId?: string;
    productId?: string;
  }): Promise<Paginated<StockMovement>> {
    const { data } = await api.get<Paginated<StockMovement>>('/stock/movements', {
      params: Object.fromEntries(
        Object.entries(params).filter(([, value]) => value !== undefined && value !== ''),
      ),
    });
    return data;
  },

  async transfer(body: CreateTransferInput): Promise<{ transferId: string }> {
    const { data } = await api.post<{ transferId: string }>('/stock/transfers', body);
    return data;
  },

  async adjust(body: CreateAdjustmentInput): Promise<StockMovement> {
    const { data } = await api.post<StockMovement>('/stock/adjustments', body);
    return data;
  },
};
